"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PartnerPage;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var _SideBar = _interopRequireDefault(require("./SideBar"));

var _LiveWidget = require("./LiveWidget");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  border-color: ", ";\n  &:hover {\n    background: ", ";\n    color: black;\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border-color: ", ";\n  color: black;\n\n  &:hover {\n    color: black;\n    background: white;\n    border-color: white;\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  z-index: 1;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  @media (min-width: 769px) {\n    width: 40%;\n  }\n\n  @media (min-width: 1400px) {\n    width: 30%;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  position: absolute;\n  left: 0;\n  top: 60px;\n  height: calc(100% - 120px);\n\n  @media (min-width: 769px) {\n    position: relative;\n    top: auto;\n    left: auto;\n    margin: 72px 0;\n    height: calc(100% - 144px);\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  padding-bottom: calc(56% + 120px);\n\n  @media (min-width: 769px) {\n    padding-bottom: 0;\n    width: auto;\n    flex: auto;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n\n  @media (min-width: 769px) {\n    min-height: ", ";\n    flex-direction: row;\n  }\n\n  @media (min-width: 1400px) {\n    min-height: ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  align-self: center;\n  margin-right: 10px;\n  font-size: 12px;\n\n  @media (min-width: 1400px) {\n    font-size: 14px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 40px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding: 10px 5px;\n  font-size: 12px;\n  text-decoration: none;\n  color: white;\n  margin: 10px;\n  border: 3px solid #131311;\n  font-weight: 700;\n  min-width: 120px;\n  font-family: GothamPro, Arial, sans-serif;\n  text-align: center;\n  text-transform: uppercase;\n  transition: all ease 0.3s;\n\n  @media (min-width: 1400px) {\n    min-width: 180px;\n    padding: 15px 10px;\n    min-width: 100px;\n    font-size: 14px;\n  }\n\n  &:hover {\n    border-color: ", ";\n    text-decoration: none;\n    color: white;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  margin-top: 60px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  @media (min-width: 769px) {\n    min-height: ", ";\n  }\n  @media (min-width: 1400px) {\n    min-height: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var brandColor = '#fef502';
var desktopHeight = '896px';
var tabletHeight = '600px';

var Page = _styledComponents.default.div(_templateObject(), tabletHeight, desktopHeight);

var LoadingContainer = _styledComponents.default.div(_templateObject2());

var Button = (0, _styledComponents.default)(_reactRouterDom.Link)(_templateObject3(), brandColor);

var TopLinksContainer = _styledComponents.default.div(_templateObject4());

var Back = (0, _styledComponents.default)(Button)(_templateObject5());

var StreamingNote = _styledComponents.default.div(_templateObject6());

var Container = _styledComponents.default.div(_templateObject7(), tabletHeight, desktopHeight);

var ContainerLeft = _styledComponents.default.div(_templateObject8());

var VideoContainer = _styledComponents.default.div(_templateObject9());

var ContainerRight = _styledComponents.default.div(_templateObject10());

var VideoIframe = _styledComponents.default.iframe(_templateObject11());

var CtaButtons = _styledComponents.default.div(_templateObject12());

var CtaButton = (0, _styledComponents.default)(Button)(_templateObject13(), brandColor, brandColor);
var CtaButtonSecondary = (0, _styledComponents.default)(Button)(_templateObject14(), brandColor, brandColor);

function PartnerPage(_ref) {
  var _ref$partners = _ref.partners,
      partners = _ref$partners === void 0 ? {} : _ref$partners,
      loading = _ref.loading;

  var _useParams = (0, _reactRouterDom.useParams)(),
      partner = _useParams.partner;

  var partnerObject = partners[partner] || {};
  var ctaButtons = partnerObject.ctaButtons,
      embedLink = partnerObject.embedLink,
      isLive = partnerObject.isLive;
  return /*#__PURE__*/_react.default.createElement(Page, null, loading ? /*#__PURE__*/_react.default.createElement(LoadingContainer, null, "Loading...") : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(ContainerLeft, null, /*#__PURE__*/_react.default.createElement(TopLinksContainer, null, /*#__PURE__*/_react.default.createElement(Back, {
    to: "/"
  }, "Back to expo"), /*#__PURE__*/_react.default.createElement(StreamingNote, null, isLive ? /*#__PURE__*/_react.default.createElement(_LiveWidget.LiveWidget, null, "Live") : 'Consult the event schedule to see when the live stream starts. ')), ctaButtons && ctaButtons.primary && ctaButtons.primary.link && ctaButtons.primary.text && /*#__PURE__*/_react.default.createElement(CtaButtons, null, /*#__PURE__*/_react.default.createElement(CtaButton, {
    as: "a",
    href: ctaButtons.primary.link,
    target: "_blank"
  }, ctaButtons.primary.text), ctaButtons.secondary && ctaButtons.secondary.link && ctaButtons.secondary.text && /*#__PURE__*/_react.default.createElement(CtaButtonSecondary, {
    as: "a",
    href: ctaButtons.secondary.link,
    target: "_blank"
  }, ctaButtons.secondary.text)), /*#__PURE__*/_react.default.createElement(VideoContainer, null, embedLink && /*#__PURE__*/_react.default.createElement(VideoIframe, {
    src: embedLink,
    frameborder: "0",
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: ""
  }))), /*#__PURE__*/_react.default.createElement(ContainerRight, null, /*#__PURE__*/_react.default.createElement(_SideBar.default, {
    partner: partnerObject
  })))));
}